<nav class="navbar navbar-default">
  <div class="container-fluid">      
    <div class="navbar-header">                  
      <span class="navbar-brand" href="#">{{title}}</span>
    </div>
    <div class="collapse navbar-collapse" *ngIf="authService.isLoggedIn()">            
      <ul class="nav navbar-nav navbar-right">
        <li >
          <a [routerLink]="'/logout'" class="btn-rotate" >
            <i class="ti-user"></i>
            <p class="hidden-md hidden-lg">
              Logout
            </p>
          </a>
        </li>
        <li *ngIf="authService.hasRole('Admin')">          
          <a [routerLink]="'/admin'" class="btn-rotate">
            <i class="ti-settings"></i>
            <p class="hidden-md hidden-lg">
              Settings
            </p>
          </a>
        </li>        
      </ul>
    </div>
  </div>
</nav>
